import * as React from 'react';
import { withAuthenticator } from 'aws-amplify-react';
import MainLayout from '../Layouts/MainLayout';

const LoginWithAuth = withAuthenticator(() => null, { includeGreetings: true });

const AuthLogin = () => (
  <MainLayout>
    <LoginWithAuth />
  </MainLayout>
);

export default AuthLogin;



// WEBPACK FOOTER //
// ./src/containers/Auth/AuthLogin.tsx